import store from 'src/js/store';
import actions from 'src/js/modules/context-menu/actions';

function showContextMenu({
  position,
  groups,
  triggerId,
  calculatePosition,
  title,
  description,
  submitButton,
  onHideExceptInsideClick,
}) {
  store.dispatch(
    actions.showContextMenu({
      position,
      groups,
      triggerId,
      calculatePosition,
      title,
      description,
      submitButton,
      onHideExceptInsideClick,
    })
  );
}

export default showContextMenu;
